import { render, staticRenderFns } from "./MbOverridesTab.vue?vue&type=template&id=26fcf274"
import script from "./MbOverridesTab.vue?vue&type=script&lang=js"
export * from "./MbOverridesTab.vue?vue&type=script&lang=js"
import style0 from "./MbOverridesTab.vue?vue&type=style&index=0&id=26fcf274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports